import { PROFILE_DETAILS_TABS } from './profile-details-tabs.model.js';

function normalizeList(value) {
  if (Array.isArray(value)) {
    return value;
  }

  return [];
}

function displayValue(value) {
  const normalized = String(value ?? '').trim();
  return normalized || '-';
}

export function buildLegalAcceptanceRows(legalAcceptances) {
  return normalizeList(legalAcceptances)
    .filter((item) => item && typeof item === 'object')
    .map((item, index) => {
      const type = displayValue(item.type);

      return {
        key: `${type}-${index}`,
        type,
        title: displayValue(item.title || item.name),
        version: displayValue(item.version),
        effectiveDate: String(item.effectiveDate || '').trim(),
        acceptedAt: String(item.acceptedAt || '').trim(),
        consentIp: displayValue(item.consentIp),
        status: displayValue(item.status),
      };
    });
}

export function shouldLoadProfileSuitability({
  activeTab,
  isFinancialRegulation,
  profileId,
  suitabilityLoaded,
}) {
  if (!isFinancialRegulation) {
    return false;
  }

  if (activeTab !== PROFILE_DETAILS_TABS.compliance) {
    return false;
  }

  if (!String(profileId || '').trim()) {
    return false;
  }

  return suitabilityLoaded !== true;
}
